var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 29,
    viewBox: "0 0 21 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5011 28.6667C8.49731 28.6665 6.53977 28.0643 4.88231 26.9383C3.22485 25.8122 1.9439 24.2142 1.20556 22.3514C0.467223 20.4886 0.30554 18.4469 0.741479 16.4911C1.17742 14.5353 2.19087 12.7556 3.65044 11.3827C5.43977 9.69867 9.83444 6.66667 9.16777 0C17.1678 5.33333 21.1678 10.6667 13.1678 18.6667C14.5011 18.6667 16.5011 18.6667 19.8344 15.3733C20.1944 16.404 20.5011 17.512 20.5011 18.6667C20.5011 21.3188 19.4475 23.8624 17.5722 25.7377C15.6968 27.6131 13.1533 28.6667 10.5011 28.6667Z",
    fill: "#B076F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.9ad5c05291c5a53c76f30cb9edeb5214.svg";
export { ForwardRef as ReactComponent };